import { makeStyles } from "@material-ui/core";

// Admissions CRM — montessori-ui tokens (white bordered panels, black pills, 8px status dots).
export default makeStyles((theme) => ({
  page: {
    padding: 28,
    [theme.breakpoints.down("xs")]: { padding: 16 },
  },
  back: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    color: "#0b5cc2",
    fontSize: 14,
    textDecoration: "none",
    marginBottom: 8,
    background: "none",
    border: 0,
    padding: 0,
    cursor: "pointer",
    "&:hover": { color: "#08407f" },
  },
  head: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
    marginBottom: 20,
  },
  h1: { fontSize: 30, fontWeight: 700, color: "#1a1a1a", margin: 0, lineHeight: 1.2, [theme.breakpoints.down("xs")]: { fontSize: 24 } },
  sub: { fontSize: 15, color: "#555", marginTop: 4 },
  headActions: { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" },
  panel: {
    background: "#fff",
    border: "1px solid #d9d9d9",
    borderRadius: 14,
    padding: 24,
    [theme.breakpoints.down("xs")]: { padding: 16 },
  },
  panelTight: { background: "#fff", border: "1px solid #d9d9d9", borderRadius: 14, overflow: "hidden" },
  panelTitle: { fontSize: 18, fontWeight: 600, color: "#1a1a1a", margin: 0 },
  muted: { color: "#555", fontSize: 13 },
  stack: { display: "grid", gap: 20 },

  /* tiles */
  tiles: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
    gap: 16,
    marginBottom: 20,
  },
  tile: {
    textAlign: "left",
    background: "#fff",
    border: "1px solid #d9d9d9",
    borderRadius: 12,
    padding: "16px 18px",
    cursor: "pointer",
    font: "inherit",
    color: "inherit",
    transition: "border-color 120ms",
    "&:hover": { borderColor: "#8f8f8f" },
    "&:focus-visible": { outline: "2px solid #1a1a1a", outlineOffset: 2 },
  },
  tileStatic: { cursor: "default", "&:hover": { borderColor: "#d9d9d9" } },
  tileActive: { borderColor: "#1a1a1a", boxShadow: "inset 0 0 0 1px #1a1a1a" },
  tileLabel: { display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#555", fontWeight: 500 },
  tileValue: { fontSize: 30, fontWeight: 700, color: "#1a1a1a", marginTop: 6, lineHeight: 1.1 },
  tileNote: { fontSize: 13, color: "#555", marginTop: 4 },

  dot: { width: 8, height: 8, borderRadius: "50%", display: "inline-block", flex: "0 0 8px" },
  status: { display: "inline-flex", alignItems: "center", gap: 6, fontSize: 14, color: "#1a1a1a", whiteSpace: "nowrap" },

  /* follow-up cards */
  cardList: { listStyle: "none", margin: 0, padding: 0 },
  card: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "14px 18px",
    borderBottom: "1px solid #ececec",
    "&:last-child": { borderBottom: 0 },
    [theme.breakpoints.down("xs")]: { flexWrap: "wrap", padding: "14px 14px" },
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    background: "#3b3b3b",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 14,
    fontWeight: 600,
    flex: "0 0 40px",
  },
  cardMain: { flex: "1 1 220px", minWidth: 0, cursor: "pointer" },
  cardName: { fontSize: 15, fontWeight: 600, color: "#1a1a1a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  cardMeta: { fontSize: 13, color: "#555", marginTop: 2, display: "flex", flexWrap: "wrap", gap: "4px 12px", alignItems: "center" },
  due: { fontWeight: 600 },
  dueOverdue: { color: "#b3261e" },
  dueToday: { color: "#8a5600" },
  dueUpcoming: { color: "#1a1a1a" },
  staleTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12,
    color: "#5c3d00",
    background: "#fbe7bd",
    borderRadius: 999,
    padding: "2px 10px",
    whiteSpace: "nowrap",
  },
  cardActions: {
    display: "flex",
    gap: 4,
    alignItems: "center",
    flex: "0 0 auto",
    [theme.breakpoints.down("xs")]: { width: "100%", justifyContent: "flex-end" },
  },
  iconBtn: {
    width: 40,
    height: 40,
    borderRadius: 8,
    color: "#1a1a1a",
    "&:hover": { background: "#f0f0f0" },
  },
  empty: { textAlign: "center", padding: "48px 16px", color: "#555" },
  emptyTitle: { fontSize: 16, fontWeight: 500, color: "#1a1a1a", margin: "10px 0 4px" },

  /* toolbar + table */
  toolbar: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    padding: "14px 18px",
    borderBottom: "1px solid #d9d9d9",
  },
  count: { fontSize: 15, fontWeight: 600, color: "#1a1a1a", marginRight: "auto" },
  search: { width: 260, [theme.breakpoints.down("xs")]: { width: "100%" } },
  filtersOn: { background: "#e6e6e6" },
  badge: {
    marginLeft: 6,
    background: "#1a1a1a",
    color: "#fff",
    borderRadius: 999,
    fontSize: 11,
    padding: "0 7px",
    lineHeight: "18px",
  },
  tableWrap: { display: "flex", flexWrap: "wrap", alignItems: "stretch" },
  tableCol: { flex: "1 1 520px", minWidth: 0 },
  tableScroll: { overflowX: "auto" },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 760,
    "& th": {
      background: "#efefef",
      fontSize: 13,
      fontWeight: 500,
      color: "#1a1a1a",
      textAlign: "left",
      padding: "10px 14px",
      whiteSpace: "nowrap",
    },
    "& td": {
      fontSize: 14,
      padding: "10px 14px",
      borderBottom: "1px solid #d9d9d9",
      verticalAlign: "middle",
      color: "#1a1a1a",
    },
    "& tbody tr": { cursor: "pointer" },
    "& tbody tr:hover": { background: "#f5f5f5" },
  },
  ellipsis: { maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  pager: { display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 8, padding: "10px 18px", fontSize: 13, color: "#555" },
  mobileOnly: { display: "none", [theme.breakpoints.down("xs")]: { display: "block" } },
  desktopOnly: { [theme.breakpoints.down("xs")]: { display: "none" } },

  /* chips (one-tap choices) */
  chips: { display: "flex", flexWrap: "wrap", gap: 8 },
  chip: {
    height: 36,
    padding: "0 14px",
    borderRadius: 999,
    border: "1px solid #c4c4c4",
    background: "#fff",
    color: "#1a1a1a",
    fontSize: 14,
    font: "inherit",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    "&:hover": { borderColor: "#8f8f8f" },
    "&:focus-visible": { outline: "2px solid #1a1a1a", outlineOffset: 2 },
  },
  chipOn: { background: "#e6e6e6", borderColor: "#1a1a1a", fontWeight: 500 },

  /* forms */
  fieldLabel: { fontSize: 13, fontWeight: 500, color: "#1a1a1a", marginBottom: 6, display: "block" },
  section: { marginBottom: 22 },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    color: "#555",
    margin: "0 0 12px",
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 14,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  full: { gridColumn: "1 / -1" },
  error: { color: "#b3261e", fontSize: 13, marginTop: 4 },
  drawer: { width: 520, maxWidth: "100vw", display: "flex", flexDirection: "column", height: "100%" },
  drawerHead: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "18px 22px", borderBottom: "1px solid #d9d9d9" },
  drawerTitle: { fontSize: 20, fontWeight: 600, margin: 0 },
  drawerBody: { padding: 22, overflowY: "auto", flex: 1 },
  drawerFoot: { display: "flex", justifyContent: "flex-end", gap: 8, padding: "14px 22px", borderTop: "1px solid #d9d9d9" },
  dialogPaper: { borderRadius: 14 },

  /* detail */
  detailGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1.3fr)",
    gap: 20,
    alignItems: "start",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  facts: { display: "grid", gridTemplateColumns: "140px 1fr", gap: "10px 12px", fontSize: 14, margin: 0 },
  factKey: { color: "#555" },
  factVal: { color: "#1a1a1a", margin: 0, wordBreak: "break-word" },
  heroName: { fontSize: 24, fontWeight: 700, margin: 0 },
  heroRow: { display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginTop: 8 },
  contactRow: { display: "flex", gap: 8, flexWrap: "wrap", marginTop: 16 },

  timeline: { listStyle: "none", margin: 0, padding: 0, position: "relative" },
  tlItem: {
    position: "relative",
    paddingLeft: 44,
    paddingBottom: 20,
    "&:before": {
      content: '""',
      position: "absolute",
      left: 17,
      top: 36,
      bottom: 0,
      width: 1,
      background: "#d9d9d9",
    },
    "&:last-child": { paddingBottom: 0 },
    "&:last-child:before": { display: "none" },
  },
  tlIcon: {
    position: "absolute",
    left: 0,
    top: 0,
    width: 36,
    height: 36,
    borderRadius: "50%",
    border: "1px solid #d9d9d9",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#1a1a1a",
  },
  tlHead: { display: "flex", flexWrap: "wrap", gap: "2px 10px", alignItems: "baseline", fontSize: 14 },
  tlTitle: { fontWeight: 600 },
  tlWhen: { color: "#555", fontSize: 13 },
  tlBody: { fontSize: 14, color: "#1a1a1a", marginTop: 4, whiteSpace: "pre-wrap" },
  tlMeta: { fontSize: 13, color: "#555", marginTop: 4 },

  /* dashboard */
  charts: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: 20,
  },
  chartBox: { height: 260, marginTop: 12 },
  legend: { display: "grid", gap: 6, marginTop: 12, fontSize: 13 },
  legendRow: { display: "flex", alignItems: "center", gap: 8 },
  legendCount: { marginLeft: "auto", fontWeight: 600 },
  funnel: { display: "grid", gap: 8, marginTop: 12 },
  funnelRow: { display: "grid", gridTemplateColumns: "170px 1fr 40px", alignItems: "center", gap: 10, fontSize: 13 },
  funnelBar: { height: 10, borderRadius: 999, background: "#1a1a1a", minWidth: 2 },
  funnelTrack: { background: "#efefef", borderRadius: 999 },
}));
